module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../ng-src/assets/fonts/glyphicons-halflings-regular.woff
// module chunks = styles